import styles from "../../../pages/superadmin/Receipts.module.css";
import { ArrowRightIcon, LeftArrow } from "../../icons/Icon";
import { useEffect, useRef, useState } from "react";

const Pagination2 = ({ mode, currentPage, setCurrentPage, totalPages = 1 }) => {
  const [inputPage, setInputPage] = useState(currentPage);
  const [isFocused, setIsFocused] = useState(false);
  const page_inp_ref = useRef(null);

  useEffect(() => {
    setInputPage(currentPage);
  }, [currentPage]);

  const handleInputChange = (e) => {
    setInputPage(e.target.value);
  };

  const handleInputBlur = () => {
    const pageNum = parseInt(inputPage);
    if (!isNaN(pageNum) && pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    } else {
      setInputPage(currentPage);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setInputPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      setInputPage(currentPage + 1);
    }
  };

  const goBtnClick = () => {
    const pageNum = parseInt(inputPage);
    if (!isNaN(pageNum) && pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    } else {
      setInputPage(currentPage);
    }
  };

  const onBlur = () => {
    setIsFocused(false);
    handleInputBlur();
  };

  const onFocus = () => {
    setIsFocused(true);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      goBtnClick();
    }
  };

  const isFirstPage = currentPage === 1;

  const isLastPage = currentPage === totalPages;

  const inp_styles = mode
    ? {
        backgroundColor: "#1B1D21",
        borderColor: "#1B1D21",
        color: "#FFFFFF",
      }
    : {};

  const prevStyle = {
    cursor: currentPage > 1 ? "pointer" : "not-allowed",
  };

  const prevArrowStyles = isFirstPage ? "grey" : mode ? "#FFFFFF" : "#000000";

  const nextStyle = {
    cursor: currentPage < totalPages ? "pointer" : "not-allowed",
  };

  const nextArrowStyles = isLastPage ? "grey" : mode ? "#FFFFFF" : "#000000";

  return (
    <div
      className={`${styles.pagination_2} ${
        mode ? styles.pagination_2_dark : ""
      }`}
    >
      <div>
        <input
          type="number"
          name="pageNo"
          id="pageNo"
          min={1}
          className={styles.page_inp}
          style={inp_styles}
          value={inputPage}
          max={totalPages}
          ref={page_inp_ref}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={handleInputChange}
          onKeyDown={(e) => onKeyDown(e)}
        />
        <span> of </span>
        <span>{totalPages}</span>
      </div>

      {isFocused ? (
        <button className={styles.go_btn} onClick={goBtnClick}>
          Go
        </button>
      ) : (
        <div className={styles.p_2_btns}>
          <span onClick={handlePrev} style={prevStyle}>
            <LeftArrow color={prevArrowStyles} />
          </span>
          <span onClick={handleNext} style={nextStyle}>
            <ArrowRightIcon color={nextArrowStyles} />
          </span>
        </div>
      )}
    </div>
  );
};

export default Pagination2;
